/* eslint-disable react/no-array-index-key */
import React, {useEffect, useState} from 'react';
import {Col, message, Row, Skeleton} from "antd";
import styles from "./index.module.scss";
import background from "../../../assets/images/team/sfondo.jpg";
import placeholderImg from "../../../assets/images/team/placeholder.png";
import injectWindowSize from "../../../hoc/injectWindowSize";
import {getTeam} from "../../../api/settings";

const Team = ({windowSize}) => {
    const {
        moreThanEqual,
    } = windowSize;

    const [teamSettings, setTeamSettings] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getTeam()
            .then(setTeamSettings)
            .catch(e => message.error(e.toString()))
    }, [])

    let colPerRow = 1;
    switch (true) {
        case moreThanEqual('lg'):
            colPerRow = 4;
            break;
        case moreThanEqual('md'):
            colPerRow = 3;
            break;
        case moreThanEqual('sm'):
            colPerRow = 2;
            break;
    }

    const {data: teamSettingsData = []} = teamSettings || {};
    const teamContentsList = [...teamSettingsData];

    while (teamContentsList.length % colPerRow > 0) {
        teamContentsList.push({
            fake: true,
        });
    }

    return (
        <Skeleton
            loading={loading}
            active
        >
            <div className={styles.teamListWrapper}>
                <Col
                    className={styles.teamTextCol}
                    xs={24}
                >
                    <h2 className={styles.teamTitle}>Il nostro team assistenza è a tua disposizione </h2>
                </Col>
                <Row
                    gutter={32}
                    className={styles.teamList}
                >
                    {
                        teamContentsList.map(
                            (member, index) => {
                                const {
                                    data: memberData,
                                    fake = false,

                                } = member || {};
                                const {
                                    name = "",
                                    role = "",
                                    img = undefined,
                                } = memberData || {};
                                const classNames = [styles.teamListItem];

                                return (
                                    <Col
                                        key={`contents_${name}_${index}`}
                                        className={classNames.join(' ')}
                                        xs={24}
                                        sm={12}
                                        md={8}
                                        lg={6}
                                    >
                                        <div className={styles.teamImgWrapper}>
                                            {
                                                fake ?
                                                    <img
                                                        src={placeholderImg}
                                                        alt={name}
                                                        className={styles.teamImgBgFake}
                                                    /> :
                                                    <>
                                                        <img
                                                            src={background}
                                                            alt="bg"
                                                            className={styles.teamImgBg}
                                                        />
                                                        <img
                                                            src={img}
                                                            title={name}
                                                            alt={name}
                                                            className={styles.teamImg}
                                                        />
                                                        <p className={styles.teamImgText}>
                                                            <strong>
                                                                {name}
                                                            </strong>
                                                            {role}
                                                        </p>
                                                    </>
                                            }
                                        </div>

                                    </Col>
                                );
                            }
                        )
                    }
                </Row>
            </div>
        </Skeleton>
    );
};

export default injectWindowSize(Team);